"use strict";
var PooledClass = require("./PooledClass");
var assign = require("./Object.assign");
var invariant = require("fbjs/lib/invariant");
function CallbackQueue() {
  this._callbacks = null;
  this._contexts = null;
}
assign(CallbackQueue.prototype, {
  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */
  enqueue: function(callback, context) {
    this._callbacks = this._callbacks || [];
    this._contexts = this._contexts || [];
    this._callbacks.push(callback);
    this._contexts.push(context);
  },
  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */
  notifyAll: function() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    if (callbacks) {
      !(callbacks.length === contexts.length) ? process.env.NODE_ENV !== "production" ? invariant(false, "Mismatched list of contexts in callback queue") : invariant(false) : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i]);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  },
  /**
   * Resets the internal queue.
   *
   * @internal
   */
  reset: function() {
    this._callbacks = null;
    this._contexts = null;
  },
  /**
   * `PooledClass` looks for this.
   */
  destructor: function() {
    this.reset();
  }
});
PooledClass.addPoolingTo(CallbackQueue);
module.exports = CallbackQueue;
